import styled from 'styled-components';

export const SelectGender = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 8px;

  @media ${({ theme }) => theme.devices.mobile} {
    gap: 8px;
  }

  button {
    width: 30%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    position: relative;
    padding: 10px 32px;
    border: none;
    color: ${({ theme }) => theme.colors.grey.white};
    border-radius: 25px;
    z-index: 0;

    @media ${({ theme }) => theme.devices.mobile} {
      width: 33%;
    }

    h4 {
      @media ${({ theme }) => theme.devices.mobile} {
        font-size: 18px;
      }
    }

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 25px;
      background: ${({ theme }) => theme.colors.gradient.fullX};
      opacity: 0.3;
      z-index: -2;
    }

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 25px;
      padding: 2px;
      background: ${({ theme }) => theme.colors.gradient.fullX};
      -webkit-mask: linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      z-index: -1;
    }

    &:hover {
      &::before {
        transition: 0.7s;
        opacity: 1;
      }
    }

    &:nth-last-of-type(${({ $select }) => $select}) {
      &::before {
        opacity: 1;
      }
    }

    &.active {
      &::before {
        opacity: 1;
      }
    }

    h2 {
      color: ${({ theme }) => theme.colors.grey.white};
      margin-bottom: -4px;
    }
  }
`;

export const Empty = styled.div`
  width: 100%;
  padding: 20px 0;
  display: ${({ $hidden }) => ($hidden ? 'none' : 'flex')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;

  img {
    width: 100%;
    max-width: 120px;
  }

  button {
    margin-top: 1rem;
    padding: 0.75rem 1.5rem;
    background: ${({ theme }) => theme.colors.primary.main};
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.2s;

    &:hover {
      background: ${({ theme }) => theme.colors.primary.dark};
      transform: translateY(-2px);
    }
  }
`;

export const GroupPlans = styled.div`
  width: 100%;
  display: ${({ $hidden }) => ($hidden ? 'none' : 'flex')};
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
  margin-top: 20px;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
    margin-top: 12px;
    gap: 20px 8px;
  }
`;

export const NotHasMoreModel = styled.div`
  width: 100%;
  padding: 20px;
  text-align: center;

  span {
    color: ${({ theme }) => theme.colors.grey.white};
  }
`;

export const LoadingMore = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 24px;

  span {
    color: ${({ theme }) => theme.colors.grey[500]};
  }
`;
